import $api from "../http";
import { IAddon, IModelForBuyingAddon } from "../models/Addon";

class AddonServiceClass {
  async getAllAddons() {
    return await $api.get<IAddon[]>("api/addons/get-all");
  }

  // async buyAddon(model: IModelForBuyingAddon) {
  //     return await $api.post<{clientKey: string}>("api/addons/buy", model);
  // }
}

export const AddonService = new AddonServiceClass();
